import { Action } from '@ngrx/store';
import { type } from '../../util';

export const ActionTypes = {
  CHECK_AGREEMENT_RESIGN: type('[Agreement Resign] check agreement'),
  STORE_AGREEMENT_RESIGN_DETAILS: type('[Agreement Resign] store agreement details'),
  FETCH_AGREEMENT_RESIGN_TERMS: type('[Agreement Resign] fetch terms'),
  SAVE_AGREEMENT_RESIGN_TERMS: type('[Agreement Resign] save terms'),
  UPDATE_SIGNATURE_FORM_DATA: type('[Agreement Resign] update signature form data'),
  SUBMIT_AGREEMENT_RESIGN: type('[Agreement Resign] submit'),
  FETCHING_END: type('[Agreement Resign] fetching end'),
};

export enum FetchingPropsEnum {
  agreement,
  terms,
}

export enum FetchingStatusEnum {
  initial,
  fetched,
  error
}

export class CheckAgreementResign implements Action {
  public type = ActionTypes.CHECK_AGREEMENT_RESIGN;

  constructor(public payload: { id: string }) {}
}

export class StoreAgreementResignDetails implements Action {
  public type = ActionTypes.STORE_AGREEMENT_RESIGN_DETAILS;

  constructor(public payload: {
    publicKey: string;
    isSigned: boolean;
    isResignNeeded: boolean;
  }) {}
}

export class FetchAgreementResignTerms implements Action {
  public type = ActionTypes.FETCH_AGREEMENT_RESIGN_TERMS;

  constructor(public payload: string) {}
}

export class SaveAgreementResignTerms implements Action {
  public type = ActionTypes.SAVE_AGREEMENT_RESIGN_TERMS;

  constructor(public payload: string) {}
}

export class UpdateSignatureFormData implements Action {
  public type = ActionTypes.UPDATE_SIGNATURE_FORM_DATA;

  constructor(public payload: {
    fieldId: string;
    value: any;
  }) {}
}

export class SubmitAgreementResign implements Action {
  public type = ActionTypes.SUBMIT_AGREEMENT_RESIGN;

  constructor(public payload?: any) {}
}

export class FetchingEnd implements Action {
  public type = ActionTypes.FETCHING_END;

  constructor(public payload: {
    field: FetchingPropsEnum;
    status: FetchingStatusEnum;
  }) {}
}

export type TypeAction =
  CheckAgreementResign |
  StoreAgreementResignDetails |
  FetchAgreementResignTerms |
  SaveAgreementResignTerms |
  UpdateSignatureFormData |
  SubmitAgreementResign |
  FetchingEnd;
